import { createContext, useContext } from 'react';

import { FacetInstanceDto, FacetKey } from '@app/components';
import { SetState } from '@app/constants';

interface FilterPanelContextProps {
  facets: Partial<FacetInstanceDto>;
  facetsToFetch: FacetKey[];
  activeFacetAttributesCount: number;
  toggleFacetAttribute: (facetKey: FacetKey, value: string) => void;
  setFacetsToFetch: SetState<FacetKey[]>;
  setStatePristine: SetState<boolean>;
  getActiveFacetAttributesCount: (facetKey: FacetKey) => number;
}

export const FilterPanelContext = createContext<FilterPanelContextProps>(null!);

export const useFilterPanelContext = (): FilterPanelContextProps =>
  useContext(FilterPanelContext);
